"use client"

import CreateGrupoPaqueteComponent from "./CreateGrupoPaqueteComponent.js"

const RecetaComponent = ({
  modoEdicion = false,
  paqueteInicial = null,
  onGuardadoExitoso = null,
  onCancelar = null,
  onBaseItemChange = null,
  nochesCalculoAutomaticoInicial = null,
}) => {
  const handleClose = () => {
    if (typeof onGuardadoExitoso === "function") {
      onGuardadoExitoso()
      return
    }

    if (typeof onCancelar === "function") {
      onCancelar()
    }
  }

  return (
    <CreateGrupoPaqueteComponent
      mode={modoEdicion ? "edit" : "create"}
      paqueteInicial={paqueteInicial}
      onClose={handleClose}
      onBaseItemChange={onBaseItemChange}
      nochesCalculoAutomaticoInicial={nochesCalculoAutomaticoInicial}
    />
  )
}

export default RecetaComponent
